import { useEffect, useState } from "react";
import api from "../services/api";
import StatsCard from "../components/StatsCard";
import TopProducts from "../components/TopProducts";
import WaveChart from "../components/WaveChart";
import BarChart from "../components/BarChart";

export default function DashboardHome() {
  const [stats, setStats] = useState({
    products: 0,
    categories: 0,
    totalClicks: 0,
  });

  const [topProducts, setTopProducts] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const token = localStorage.getItem("token");

        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };

        const [statsRes, topRes, chartRes] = await Promise.all([
          api.get("http://localhost:5000/api/products/dashboard/stats", config),
          api.get("http://localhost:5000/api/products/dashboard/top-products", config),
          api.get("http://localhost:5000/api/products/dashboard/clicks-period", config),
        ]);

        setStats(statsRes.data);
        setTopProducts(topRes.data || []);
        setChartData(chartRes.data || []);
      } catch (err) {
        console.error("Dashboard API error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  if (loading) return <p className="text-muted">Loading dashboard...</p>;

  return (
    <>
      {/* STAT */}
      <div className="row g-3 mb-4">
        <StatsCard title="Total Produk" value={stats.products} />
        <StatsCard title="Kategori Produk" value={stats.categories} />
        <StatsCard title="Total Klik" value={stats.totalClicks} />
      </div>

      {/* CHARTS */}
      <div className="row g-4 mb-4">
        <div className="col-md-6">
          <div className="card p-3 shadow-sm">
            <h6 className="fw-bold mb-3">📈 Klik Produk (Wave)</h6>
            <WaveChart data={chartData} />
          </div>
        </div>

        <div className="col-md-6">
          <div className="card p-3 shadow-sm">
            <h6 className="fw-bold mb-3">📊 Klik Produk (Batang)</h6>
            <BarChart data={chartData} />
          </div>
        </div>
      </div>

      {/* TOP PRODUCTS */}
      <TopProducts data={topProducts} />
    </>
  );
}
